export default {
	data() {
		return {
			messageSettings: {
				fastPolling: 7500,
				mediumPolling: 30000,
				slowPolling: 60000,
				inactiveTimer: 120000
			}
		}
	},
	methods: {
		matchProfileImages(images,messages) {
			//iterate the messages, and returned profile images to match them up with the message authors
			if (messages && images) {
				messages.forEach(message => {
					images.forEach(image => {

						if (image.id == message.Author.image_id)
							message.imageUrl = window.apiRoot+"resources/profile-images/"+image.slug+"/"+image.filename

					})
				})
			}
		}
	}
}